var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 269.48 35.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Unbenannter_Verlauf_3-3);\n      }\n\n      .cls-2 {\n        fill: url(#Unbenannter_Verlauf_3-2);\n      }\n\n      .cls-3 {\n        fill: url(#Unbenannter_Verlauf_3);\n      }\n\n      .cls-4 {\n        fill: url(#Unbenannter_Verlauf_4);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_3",
    "data-name": "Unbenannter Verlauf 3",
    cx: 914.56,
    cy: 3220.5,
    fx: 914.56,
    fy: 3220.5,
    r: 0.48,
    gradientTransform: "translate(-60470.72 213894.95) scale(66.41 -66.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdde33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fab709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ed950d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e07a10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_3-2",
    "data-name": "Unbenannter Verlauf 3",
    cx: 914.71,
    cy: 3219.96,
    fx: 914.71,
    fy: 3219.96,
    r: 0.48,
    gradientTransform: "translate(-60533.59 213984.64) scale(66.46 -66.46)",
    xlinkHref: "#Unbenannter_Verlauf_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_3-3",
    "data-name": "Unbenannter Verlauf 3",
    cx: 915.08,
    cy: 3220.35,
    fx: 915.08,
    fy: 3220.35,
    r: 0.48,
    gradientTransform: "translate(-60557.37 213948.65) scale(66.43 -66.43)",
    xlinkHref: "#Unbenannter_Verlauf_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_4",
    "data-name": "Unbenannter Verlauf 4",
    cx: 914.62,
    cy: 3220.4,
    fx: 914.62,
    fy: 3220.4,
    r: 0.48,
    gradientTransform: "translate(-60665.23 214559.6) scale(66.62 -66.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdde33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fab709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ed950d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d77301"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path201",
    className: "cls-3",
    d: "M254.5,0c-.74,0-2.95,0-5.51,3.11h0s.07,.08,.1,.12h0c.66-.77,1.48-1.56,2.37-2.13h0c.82-.53,1.77-.88,2.55-.97h0c.57-.06,2.47-.04,4.63-.04h0s.02,0,.02,.01h0l-.06-.09s-.01-.01-.02-.01h-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path225",
    className: "cls-2",
    d: "M239.47,0s-.02,0-.02,.01h0l-8.02,13.9-2.52,4.36-.29,.51-.04,.06s0,.01,0,.02h0l7.64,13.24v-.05c-.17-.3-.29-.54-.35-.69h0c-.32-.72-.5-1.73-.45-2.7h0c.13-2.56,1.49-5.09,2.18-6.28h0c1.61-2.78,4.71-8.17,4.71-8.17h0s3.11-5.38,4.72-8.17h0c.68-1.19,2.19-3.63,4.35-5.02h0c.82-.53,1.78-.87,2.56-.96h0c.57-.06,2.48-.07,4.64-.07h-19.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path249",
    className: "cls-1",
    d: "M228.65,18.97c.12,.21,.24,.42,.36,.62h0l-.36-.62Zm38.45,3.88c-.47,.64-1.24,1.3-2.11,1.74h0c-2.29,1.17-5.16,1.25-6.52,1.25h-18.86c-1.37,0-4.24-.08-6.52-1.25h0c-.87-.44-1.64-1.1-2.11-1.74h0c-.3-.4-1.06-1.7-1.96-3.26h0l1.92,3.32,7.22,12.5s.01,.01,.02,.01h21.74s.02,0,.02-.01h0l9.47-16.4c-1.04,1.81-1.96,3.38-2.29,3.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path273",
    className: "cls-4",
    d: "M253.94,.07c-.78,.09-1.74,.43-2.56,.96h0c-.9,.58-1.69,1.35-2.35,2.13h0c.92,1.09,1.6,2.2,2,2.89h0c1.61,2.78,4.72,8.17,4.72,8.17h0s3.11,5.38,4.72,8.17h0c.68,1.19,2.05,3.72,2.17,6.28h0c.05,.97-.14,1.97-.45,2.7h0c-.22,.51-1.1,2.04-2.13,3.82h0l9.42-16.32s0,0,0,0h0s0-.02,0-.02h0L258.61,.01s-.01-.01-.02-.01h0c-2.16,0-4.07,0-4.64,.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path177",
    d: "M9.67,9.65C4.29,9.65,0,14.07,0,19.63s4.21,9.82,9.41,9.82c2.98,0,5.28-1.07,7.04-3.07l-2.6-2.66c-1.07,1.15-2.43,1.77-4.18,1.77-3.05,0-5.1-2.55-5.1-5.96s2.1-5.93,5.04-5.93c1.54,0,2.85,.58,3.93,1.62l2.69-2.79c-1.58-1.72-3.91-2.79-6.56-2.79Zm18.22,0c-5.7,0-9.98,4.46-9.98,9.98s4.05,9.82,9.86,9.82,9.98-4.46,9.98-9.98-4.05-9.82-9.86-9.82Zm14.48,.32l-1.87,19.14h3.96l.89-10.33c.18-2.01,.19-4.09,.19-4.09h.1s.44,2.09,1.01,3.99l3.23,10.43h3.77l3.23-10.52c.57-1.83,1.01-3.9,1.01-3.9h.06s.04,2.07,.22,4.15l.86,10.27h4.21l-1.87-19.14h-5.55l-2.92,9.48c-.47,1.54-.95,3.52-.95,3.52,0,0-.51-1.97-1.01-3.55l-2.95-9.44h-5.64Zm26.68,0l-1.84,19.14h3.96l.86-10.33c.18-2.01,.22-4.09,.22-4.09h.06s.47,2.09,1.05,3.99l3.23,10.43h3.77l3.2-10.52c.57-1.83,1.01-3.9,1.01-3.9h.06s.04,2.07,.22,4.15l.86,10.27h4.25l-1.87-19.14h-5.55l-2.92,9.48c-.47,1.54-.95,3.52-.95,3.52,0,0-.51-1.97-1.01-3.55l-2.95-9.44h-5.67Zm25.48,0V29.11h12.45v-3.68h-8.27v-4.18h7v-3.58h-7v-4.06h8.14v-3.64h-12.33Zm17.37,0V29.11h4.18v-6.97h1.3l4.09,6.97h4.98l-4.72-7.7c2.47-.93,3.87-2.85,3.87-5.32,0-3.87-2.18-6.12-7.95-6.12h-5.74Zm17.18,0v3.64h7.73l-7.92,12.33v3.17h13.34v-3.68h-8.11l7.92-12.33v-3.14h-12.96Zm17.46,0V29.11h7.32c3.41,0,7.19-1.54,7.19-5.51,0-2.47-1.58-4.15-4.09-4.47v-.03c1.97-.61,3.2-2.1,3.2-4.21,0-4.16-3.67-4.91-7-4.91h-6.62Zm22.72,0l-6.81,19.14h4.18l1.33-3.9h7.45l1.33,3.9h4.5l-6.81-19.14h-5.17Zm14.58,0V29.11h3.87v-9.09c0-1.72-.13-3.49-.13-3.49,0,0,.9,1.54,1.9,3.04l6.5,9.54h3.71V9.96h-3.9v8.68c0,1.72,.13,3.45,.13,3.45,0,0-.9-1.54-1.9-3.04l-6.21-9.09h-3.96Zm20.44,0V29.11h4.15v-8.97l6.12,8.97h5.13l-7.04-10.27,6.37-8.87h-4.82l-5.77,8.59V9.96h-4.15ZM27.82,13.55c3.3,0,5.42,2.62,5.42,6.02,0,3.23-2.05,5.99-5.42,5.99s-5.42-2.62-5.42-6.02c0-3.23,2.05-5.99,5.42-5.99Zm88.26,0h1.71c2.22,0,3.52,.67,3.52,2.54s-1.19,2.57-3.52,2.57h-1.71v-5.1Zm34.61,0h2.41c1.33,0,2.66,.42,2.66,2s-1.14,2.15-2.47,2.15h-2.6v-4.15Zm21.01,.29s.36,1.3,.82,2.69l1.68,5.07h-5.01l1.68-5.04c.47-1.43,.82-2.73,.82-2.73Zm-21.01,7.38h3.07c1.86,0,3.07,.59,3.07,2.09s-.96,2.22-3.07,2.22h-3.07v-4.31Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.ae1333d2afbd129b4f19355179e49215.svg";
export { ForwardRef as ReactComponent };